import React, { useEffect, useState, useRef } from "react";
import { set, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import { createSlug } from "../../util/fn";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import {
  Input,
  CKEditorInput,
  SelectInput,
  RenderInputFields,
  SubmitButton,
  SubTab,
  SubInput,
  Textarea,
} from "../Form/Form";
import { error } from "jquery";

const Edit = (props) => {
  const { id: notificationTemplateId } = props.match.params;

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    trigger,
    control,
    getValues,
    clearErrors,
  } = useForm();

  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);

  const [ActionData, setActionData] = useState({});
  const [editConstants, setEditConstants] = useState([]);

  const [editInitialData, setEditInitialData] = useState({});

  const [activeTab, setActiveTab] = useState("en"); // State to track active tab index

  const { response, request } = useRequest();

  //for initialeditdata
  const { response: responseinitialeditdata, request: requestinitialeditdata } =
    useRequest();

  //for actiondata
  const { response: responseeditactiondata, request: requesteditactiondata } =
    useRequest();

  //for constant data
  const {
    response: responseeditconstantdata,
    request: requesteditconstantdata,
  } = useRequest();

  useEffect(() => {
    requestinitialeditdata(
      "GET",
      `notification-template/single/${notificationTemplateId}`
    );
    document.title = "Edit Notification Template - Easyspare";
  }, []);

  useEffect(() => {
    if (responseinitialeditdata) {
      setEditInitialData(responseinitialeditdata?.data || []);

      if (responseinitialeditdata?.data?.translations) {
        for (const key in responseinitialeditdata?.data?.translations) {
          setValue(
            `subject-${key}`,
            responseinitialeditdata?.data?.translations[key].subject
          );
          setValue(
            `body-${key}`,
            responseinitialeditdata?.data?.translations[key].body
          );
        }
      }
    }
  }, [responseinitialeditdata]);

  const handleTabChange = (lang) => {
    const language = lang;
    setActiveTab(language); // Update active tab index when tab is changed
  };

  //action data
  useEffect(() => {
    requesteditactiondata("GET", `notification-action/all`);
  }, []);

  useEffect(() => {
    if (responseeditactiondata) {
      setActionData(responseeditactiondata?.notificationActions || []);
    }
  }, [responseeditactiondata]);

  //setting the form with preloaded data
  useEffect(() => {
    if (editInitialData && ActionData.length > 0) {
      const { action, category, constants, name } = editInitialData;
      const selectedActionObject = ActionData.find(
        (action) => action.action === editInitialData.action
      );

      setValue("name", name);
      setValue("action", selectedActionObject?._id);
      setSelectedAction(action);
      setEditConstants(constants);
      setValue("category", category);
      // setValue(`subject.${activeTab}`, subjectdata[0]);
      // setValue(`body.${activeTab}`, bodydata[0]);
      // setValue(`subject.ar-ar`, subjectdata[1]);
      // setValue(`body.ar-ar`, bodydata[1]);
    }
  }, [editInitialData, ActionData]);

  //constant data
  useEffect(() => {
    if (responseeditconstantdata) {
      setEditConstants(responseeditconstantdata?.notificationAction?.constants);
    }
  }, [responseeditconstantdata]);

  useEffect(() => {
    if (response) {
      toast.success(response.message);
      history.push("/notification-template");
    }
  }, [response]);

  const [selectedActionData, setSelectedAction] = useState("");

  const constantHandler = (id) => {
    if (!id) {
      return;
    }
    // Find the selected action in ActionData by its ID
    const selectedActionObject = ActionData.find((action) => action._id === id);

    if (selectedActionObject) {
      // Update the selectedAction state variable with the value of action.action
      setSelectedAction(selectedActionObject.action);
    }
    requesteditconstantdata("GET", `notification-action/${id}`);
  };

  const insertConstantHandler = () => {
    const constant = getValues("constant");

    if (constant.length === 0) {
      return;
    }
    // Determine the key based on the active tab
    const key = activeTab;
    // Get the current value of the body textarea
    let bodyObject = getValues("body-" + key);

    // Concatenate the constant with the current value
    bodyObject = bodyObject + "$" + `{${constant}}`;

    // Set the new value back into the body textarea
    setValue("body-" + key, bodyObject);
  };

  const extractVariables = (bodyContent) => {
    const regex = /\{([^\}]+)\}/g;
    const matches = bodyContent.match(regex);
    if (matches) {
      return matches.map((match) => match.replace(/\{|\}/g, ""));
    }
    return [];
  };

  // Function to generate body content with dynamic variables
  const generateBody = (variables) => {
    let body = "";
    variables.forEach((variable) => {
      body += `{${variable}} `;
    });
    return body.trim();
  };

  const onSubmit = (data) => {
    // Extract relevant information from the form data
    const { name } = data;

    let translations = {};
    languages?.forEach((lang) => {
      translations[lang.code] = {
        subject: data[`subject-${lang.code}`],
        body: data[`body-${lang.code}`],
        variables: extractVariables(data[`body-${lang.code}`]),
      };
    });
    // Generate messages
    const Message = {
      name,
      action: selectedActionData,
      // category,
      isActive: true,
    };

    Message.translations = translations;

    if (Message) {
      request(
        "PUT",
        `notification-template/update/${notificationTemplateId}`,
        Message
      );
    }
  };

  // Function to insert constants into body content
  const insertConstants = (bodyContent, constant) => {
    return bodyContent.replace(/{constant}/g, constant);
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "Name",
        type: "text",
        name: "name",
        registerFields: {
          required: true,
        },
      },
      // {
      //   Component: SelectInput,
      //   label: "Category",
      //   name: "category",
      //   registerFields: {
      //     required: true,
      //   },
      //   children: (
      //     <>
      //       <option value="">{"Select Category"}</option>
      //       <option value="order">Order </option>
      //       <option value="orderOffer">OrderOffer </option>
      //       <option value="orderCancel">OrderCancel </option>
      //       <option value="orderReturn">OrderReturn </option>
      //       <option value="orderConfirm">OrderConfirm </option>
      //       <option value="orderComplete">OrderComplete </option>
      //     </>
      //   ),
      // },
      {
        Component: SelectInput,
        label: "Action",
        name: "action",
        registerFields: {
          required: true,
          minLength: 1,
        },
        inputData: {
          disabled: true,
        },
        isEdit: true,
        onChange: constantHandler,
        children: (
          <>
            <option value="">{"Select Page Name"}</option>
            {ActionData.length > 0 &&
              ActionData.map((action) => (
                <option
                  key={action._id}
                  value={action._id}
                  name={action.action}
                >
                  {action.action}
                </option>
              ))}
          </>
        ),
      },
      {
        Component: SelectInput,
        label: "Constants",
        name: "constant",
        registerFields: {},
        children: (
          <>
            <option value="">{"Select Constant"}</option>
            {editConstants?.length > 0 &&
              editConstants?.map((constant, index) => (
                <option key={index} value={constant}>
                  {constant}
                </option>
              ))}
          </>
        ),
        moreData: (
          <button
            onClick={insertConstantHandler}
            type="button"
            className="btn btn-success font-weight-bold text-uppercase px-9 py-4"
          >
            Insert
          </button>
        ),
      },
    ],
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit Notification Template"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: "/notification-template",
            name: "Back To Notification Template",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div className="card-header">
              <h3 className="card-title">Edit Notification Template</h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <RenderInputFields
                        InputFields={InputFields}
                        errors={errors}
                        register={register}
                      />
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                  onClick={() => handleTabChange(lang.code)}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <SubInput
                                key={index}
                                index={index}
                                errors={errors}
                                register={register}
                                required={lang.required}
                                control={control}
                                code={lang.code}
                                tabName={`language_${index}`}
                                InputFields={[
                                  // Language-specific input fields for each language
                                  // For example, for English (lang.code === 'en')
                                  [
                                    {
                                      Component: Input,
                                      label: "Subject",
                                      type: "text",
                                      name: `subject`,
                                      registerFields: {
                                        required: true,
                                      },
                                    },
                                  ],
                                  [
                                    {
                                      Component: Textarea,
                                      colClass: "col-xl-12 h-100",
                                      textareaHeight: "height-full",
                                      label: "Body",
                                      name: `body`,
                                      registerFields: {
                                        required: true,
                                        setValueAs: (v) => v.trim(),
                                      },
                                    },
                                  ],
                                ]}
                              ></SubInput>
                            ))}
                        </div>
                      </div>
                    </div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                      pxclassName="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
